import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text } from "@zillow/constellation-10";
import React from "react";
import { getWholeDollars } from "../../../utils/zhl-calculator.esm.js";
const AffordabilityDescription = ({
  aggressive,
  customPayment,
  affordabilityByDTI
}) => /* @__PURE__ */ jsxs(Box, { css: {
  textAlign: "center"
}, children: [
  /* @__PURE__ */ jsxs(Text, { "aria-live": "polite", "aria-atomic": "true", textStyle: "heading-sm", children: [
    "You can afford a house up to",
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-md", css: {
      display: "block"
    }, children: getWholeDollars(affordabilityByDTI) })
  ] }),
  /* @__PURE__ */ jsxs(Text, { textStyle: "body", children: [
    customPayment && /* @__PURE__ */ jsx(React.Fragment, { children: "A house at this price would keep you within your monthly payment budget. You could afford more with a bigger down payment." }),
    aggressive && /* @__PURE__ */ jsxs(React.Fragment, { children: [
      "Based on your income, a house at this price",
      /* @__PURE__ */ jsx("br", {}),
      "may",
      " ",
      /* @__PURE__ */ jsx(Text, { css: {
        color: "text.accent.red.strong"
      }, children: "stretch your budget" }),
      " ",
      "too thin."
    ] }),
    !customPayment && !aggressive && /* @__PURE__ */ jsxs(React.Fragment, { children: [
      "Based on your income, a house at this price",
      /* @__PURE__ */ jsx("br", {}),
      "should",
      " ",
      /* @__PURE__ */ jsx(Text, { css: {
        color: "text.accent.green.hero"
      }, children: "fit comfortably" }),
      " ",
      "within your budget."
    ] })
  ] })
] });
export {
  AffordabilityDescription as default
};
